import StringHelpers from './StringHelpers'
import LookupData from './LookupData'


export default class {

    static filterObjectToArray(filterObject) {
        let operators = LookupData.operators()
        let arr = []
        for(let nameProp in filterObject) {
            if(filterObject.hasOwnProperty(nameProp)) {
                let name = nameProp                             // eg first_name
                let nameTree = filterObject[nameProp]
                for(let typeProp in nameTree) {
                    if(nameTree.hasOwnProperty(typeProp)) {
                        let type = StringHelpers.capitalizeFirstLetter( typeProp )                    // eg Visible
                        let typeTree = nameTree[typeProp]
                        let operator = typeTree['operator']
                        operator = operators.find(o=> o.code == operator).name
                        let values = typeTree['values']
                        
                        arr.push({
                            name,
                            type,
                            operator,
                            values,
                        })
                    }
                }
            }    
        }
        return arr
    }

    static filterArrayToObject(filterArray) {

        let filterObject = {}

        filterArray.forEach(filterRecord => {
            let typeString = filterRecord.type.toLowerCase()
            let operatorString = StringHelpers.acronym(filterRecord.operator).toLowerCase()
            let valuesArray = filterRecord.values

            filterObject[filterRecord.name] = filterObject[filterRecord.name] || {}
            filterObject[filterRecord.name][typeString] = {}
            filterObject[filterRecord.name][typeString]['operator'] = operatorString 
            filterObject[filterRecord.name][typeString]['values'] = valuesArray
        })
        return filterObject
    }

}


// WEBPACK FOOTER //
// ./src/helpers/FilterHelpers.js